import React from "react";
import { Hero, TimelineNotebook } from "../../components";

function Notebook() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Notebook"}>
        9 months of research {" "}
        <span className="text-lg font-black text-VertPastel md:text-xl lg:text-2xl">
          in a nutshell.
        </span>
      </Hero>

      <div className="flex w-full px-[24px] md:px-[70px] justify-center items-center">
        <div
          className="flex justify-center items-center mx-auto flex-col md:max-w-[1500px] gap-[30px]"
          id="page-content"
        >
          <TimelineNotebook />
        </div>
      </div>
    </div>
  );
}

export default Notebook;
